export default "__VITE_ASSET__dpRfBs6J__"